import { ComponentProps, ReactElement } from 'react';
import './BoxStack.scss';
import { StackBox } from 'app/agriculture/components/BoxStack/components/StackBox/StackBox';

interface BoxStackProps {
    // children should only be <BoxStack.Box /> components
    children:
        | ReactElement<ComponentProps<typeof StackBox>>
        | ReactElement<ComponentProps<typeof StackBox>>[];
}

function BoxStack({ children }: BoxStackProps) {
    return (
        <div className="BoxStack" data-testid="BoxStack">
            {children}
        </div>
    );
}

BoxStack.Box = StackBox;

export { BoxStack };
